__turbopack_context__.v({
  "container": "overview_anchor-module-scss-module__BRMnxa__container",
  "container__menu__item": "overview_anchor-module-scss-module__BRMnxa__container__menu__item",
  "container__sub_menu__item": "overview_anchor-module-scss-module__BRMnxa__container__sub_menu__item",
  "container__title": "overview_anchor-module-scss-module__BRMnxa__container__title",
});
